"use client";
import { withCmsDataHandling as t } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import { resolveLink as i } from "../../../helpers/index.js";
import { Footer as p } from "@ingeniorforeningen/figurine-core";
const n = (e) => ({
  contact: {
    header: e.properties?.contactHeader,
    description: e.properties?.contactContent,
    phone: e.properties?.phoneLink && i(e.properties?.phoneLink?.[0]),
    mail: e.properties?.mailLink && i(e.properties?.mailLink?.[0])
  },
  socials: {
    facebookUrl: e.properties?.facebookLink,
    linkedInUrl: e.properties?.linkedInLink,
    instagramUrl: e.properties?.instagramLink,
    twitterUrl: e.properties?.xLink
  },
  relatedSitesHeader: e.properties?.externalLinksHeader,
  relatedSites: e.properties?.externalLinks ? e.properties?.externalLinks.map((r) => i(r)) : [],
  links: e.properties?.linkList?.items && e.properties?.linkList?.items.map((r) => ({
    header: r.content?.properties?.title,
    items: r.content?.properties?.linkList ? r.content?.properties?.linkList?.map((o) => i(o)) : []
  }))
}), m = t({
  Component: p,
  deliveryApiParser: n
});
export {
  m as Footer,
  n as deliveryApiFooterParser
};
